import smile from './smile.hugo'
import closeEyes from './closeEyes.hugo'
import zwinker from './zwinker.hugo'
import loading from './loading.hugo'
import blankInversed from './blankInversed.hugo'
import madInversed from './madInversed.hugo'
import sing from './sing.hugo'
import legal from './legal.hugo'
import matrix from './matrix.hugo'
import hireAlex from './hireAlex.hugo'

export default {
    smile,
    closeEyes,
    zwinker,
    loading,
    blankInversed,
    madInversed,
    sing,
    legal,
    matrix,
    hireAlex,
}